import { Formatter } from '@/filters/formatter'
import { Options, PointLabelObject, TooltipFormatterContextObject } from 'highcharts'

export const StatisticalAnalysisViewDetailChartTypeChartsFactoryColumnStacked: Options = {
    chart: {
        type: 'column'
    },
    xAxis: {
        crosshair: true
    },
    yAxis: {
        min: 0
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                formatter: function() {
                    const context: PointLabelObject = this
                    return `${Formatter.number(context.y)}`
                }
            }
        }
    },
    tooltip: {
        useHTML: true,
        formatter: function() {
            const context: TooltipFormatterContextObject = this
            return `
                <span>${context.x}</span><br>
                <span style="color:${context.color}">${context.series.name}</span>: <b> ${Formatter.number(context.y)}</b><br/>`
        }
    }
}
